import { createApp } from 'vue';
import Uploader from './Uploader.vue';
require('./_Uploader.less');

document.addEventListener('DOMContentLoaded', () =>{
    let rootId = 'uploader';
    let rootElement = document.getElementById(rootId)

    if (rootElement) {

        let app = createApp(Uploader, {
                maxFileSize: parseInt(rootElement.getAttribute('data-max-file-size')),
                maxImageSize: parseInt(rootElement.getAttribute('data-max-image-size')),
                uploadUrl: rootElement.getAttribute('data-upload-url'),
                initDoResize: rootElement.getAttribute('data-do-resize') === 'true',
                googlePickerUrls: {
                    googlePickerUrlManageAccounts: rootElement.getAttribute('data-google-picker-url-manage-accounts'),
                    googlePickerUrlGetAccounts: rootElement.getAttribute('data-google-picker-url-get-accounts'),
                    googlePickerUrlNewSession: rootElement.getAttribute('data-google-picker-url-new-session'),
                    googlePickerUrlGetSession: rootElement.getAttribute('data-google-picker-url-get-session'),
                    googlePickerUrlGetImages: rootElement.getAttribute('data-google-picker-url-get-images'),
                    googlePickerUrlGetImage: rootElement.getAttribute('data-google-picker-url-get-image'),
                    googlePickerUrlGetVideo: rootElement.getAttribute('data-google-picker-url-get-video'),
                },
                i18n: JSON.parse(rootElement.getAttribute('data-i18n')),
            }
        );
        app.mount(rootElement);
    }
});
